import React from 'react';

import customClientConfig from '../../../customClientConfig';
import FooterLines from './FooterLines';

const BurnFooterComponent = ({ tenant }) => {
  const { footerLines } = customClientConfig[tenant];

  return (
    <div
      className="footer burn-footer"
      style={{ backgroundColor: '#000', color: '#fff', padding: '22px 16px', height: 'auto' }}
    >
      <div>
        <FooterLines lines={footerLines} lineStyle={{ margin: '6px 0', fontSize: 12 }} />
      </div>
    </div>
  );
};

export default BurnFooterComponent;
